export default __webpack_public_path__ + "static/media/agendamento.607700db.png";